var products_on_page = $('.products-on-page');
var next_url = products_on_page.data('next-url');

var load_more_btn = $('.load-more__btn');
var load_more_spinner = $('.load-more__spinner');

// Quickview and Wishlist loading fixed
function loadMoreProducts () {
  $.ajax({
    url: next_url,
    type:'GET',
    dataType:'html',
    beforeSend: function () {
      load_more_btn.hide();
      load_more_spinner.show();
    }
  }).done(function(next_page) {
  var new_products_html = $(next_page).find('.products-on-page').html();
  products_on_page.append(new_products_html);

  if (typeof iwishCheckColl === "function") {
    iwishCheckColl();
  }

  load_more_spinner.hide();
  var new_url = $(next_page).find('.products-on-page').data('next-url');
  if(new_url) { load_more_btn.show(); next_url = new_url; }

  });
}
// Quickview and Wishlist loading fixed

// function loadMoreProducts () {

// $.ajax (
// 	{
// 		url: next_url,
// 		type:'GET',
// 		dataType:'html',
// 		beforeSend: function () {
// 			load_more_btn.hide();
// 			load_more_spinner.show();
// 		}
// 	}
// ).done(function(next_page) {
// 	console.log("Load More after call function");
  
  
// 	//Quick View Fix MKT 17-09-2020
//     $(document).ready(function () {
//       $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function() {
//         quickView();
//       });
//     });
//     //Quick View Fix MKT 17-09-2020
  
//     //Image and Color Switch Fix MKT 17-09-2020
//     setTimeout(function(){
//       $(document).ready(function () {
//         $.getScript("https://cdn.shopify.com/s/files/1/0426/0619/8947/t/2/assets/theme.min.js?v=1500394647907407594").done(function() {
//         });
//       });
//     }, 200);
//     //Image and Color Switch Fix MKT 17-09-2020
    



// load_more_spinner.hide();	

// var new_products = $(next_page).find('.products-on-page');
// var new_url = new_products.data('next-url');

// if(new_url)
// 	load_more_btn.show();

	

// next_url = new_url;

// products_on_page.append(new_products.html());
// if($(".collection_feature_img").length>1)
// {
// 	$(".collection_feature_img:last").remove();
// }

// });

// }